import { useHistory } from 'react-router';

import { FrequentPassageRequestForm } from '@shared/frequent-passage-requests/components/FrequentPassageRequestForm';
import { createFrequentPassageRequest } from '@shared/frequent-passage-requests/endpoints/createFrequentPassageRequest';
import { Portlet } from '@shared/ui/components/Portlet';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';

export function CreateFrequentPassageRequest() {
  const { push } = useHistory();

  return (
    <AdminWrapper
      title="Create Frequent Passage Request"
      breadcrumb={{ label: 'Frequent Passage Requests', url: '/admin/frequent-passage-requests' }}
    >
      <Portlet>
        <FrequentPassageRequestForm
          action={createFrequentPassageRequest}
          onSaveAndReturn={() => push('/admin/frequent-passage-requests')}
          onCancel={() => push('/admin/frequent-passage-requests')}
        />
      </Portlet>
    </AdminWrapper>
  );
}
